import React from 'react';

export const HomeFilledSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6349_58448)">
      <path
        d="M498.195 222.695C498.184 222.684 498.172 222.672 498.16 222.66L289.305 13.8125C280.402 4.90625 268.566 0 255.977 0C243.387 0 231.551 4.90234 222.645 13.8086L13.8984 222.551C13.8281 222.621 13.7578 222.695 13.6875 222.766C-4.59377 241.152 -4.56252 270.984 13.7773 289.324C22.1562 297.707 33.2226 302.563 45.0547 303.07C45.5351 303.117 46.0195 303.141 46.5078 303.141H54.832V456.84C54.832 487.254 79.5781 512 110 512H191.711C199.992 512 206.711 505.285 206.711 497V376.5C206.711 362.621 218 351.332 231.879 351.332H280.074C293.953 351.332 305.242 362.621 305.242 376.5V497C305.242 505.285 311.957 512 320.242 512H401.953C432.375 512 457.121 487.254 457.121 456.84V303.141H464.84C477.426 303.141 489.262 298.238 498.172 289.332C516.531 270.961 516.539 241.078 498.195 222.695V222.695Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default HomeFilledSvg;
